// Single place where the frontend gets "where is the backend?".
// In development: same host as the page (port 3000) — CRA dev server proxies /api (see setupProxy.js).
// In production: REACT_APP_API_BASE_URL if set; otherwise same origin (nginx proxies /api).
function getApiBaseUrl(): string {
  const fromEnv = process.env.REACT_APP_API_BASE_URL?.trim();
  if (typeof window !== 'undefined') {
    // Dev + default prod: API via same origin (/api proxied). Avoid :8080 in .env breaking cookies.
    const isDev = process.env.NODE_ENV === 'development';
    if (isDev || !fromEnv) {
      return window.location.origin;
    }
    return fromEnv.replace(/\/$/, '');
  }
  return fromEnv ? fromEnv.replace(/\/$/, '') : '';
}

export const API_BASE_URL = getApiBaseUrl();
